export async function sha256hex(input: string): Promise<string> {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(input))
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('')
}

export async function generateNonce(): Promise<{ hashedNonce: string; rawNonce: string }> {
    const rawNonce = crypto.randomUUID().replace(/-/g, '')
    const hashedNonce = await sha256hex(rawNonce)
    return { hashedNonce, rawNonce }
}
